import { z } from 'zod'

export const bankSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
  literalCode: z.string(),
  photo: z.string().nullable(),
  active: z.boolean(),
  origin: z.boolean()
})

export type Bank = z.infer<typeof bankSchema>
